module.exports = __webpack_public_path__ + "static/media/15.44101248.JPG";